import React, { Activity } from 'react';
import { useBehavior, useButton } from '@libs/hooks';
import { TWidgetProps } from '@libs/types';
import { TMenuButtonData } from '../../types/data';
import { TMenuButtonOptions } from '../../types/options';
import { RowRegular } from '../UI/Row/RowRegular';

export const ButtonMenu = ({ widget }: TWidgetProps<TMenuButtonData, TMenuButtonOptions>) => {
    const { isHidden, isDisabled } = useBehavior(widget);
    const { handleClick } = useButton(widget);
    const data = widget.data ?? {};
    const messages = data.messages ?? {};
    const options = widget.options ?? {};
    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <RowRegular
                isDisabled={isDisabled}
                isHide={isHidden}
                uid={widget.uid}
                title={messages.label}
                metaText={messages.metaText}
                metaHierarchy={'secondary'}
                iconName={options.iconName}
                margin={options.margin}
                handleClick={handleClick}
            />
        </Activity>
    );
};
